import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const usersModule = {
  namespaced: true,
  state() {
    return {
      currentUser: null,
    };
  },
  actions,
  getters,
  mutations,
};

export default usersModule;
